<template>
  <div>
    <bar-manut single-entity="Natureza Financeira" plural-entity="Naturezas Financeira" :crud="this.crud"
      :btn-delete="true" @closeform="closeForm" @delete="handleDelete" @save="handleSave">
    </bar-manut>
    <div id="natfin">
      <div class="default-container">
        <!-- <div class="row">
                <form-field v-model="natfin.codnatfin" :metadata="metadata.natfin.codnatfin" type="text" col="2" :disabled="true"></form-field>
            </div> -->
        <div class="row">
          <form-field ref="descricao" v-model="natfin.descricao" type="text" col="6" :metadata="metadata.natfin.descricao"
            name="descricao" :v-errors="errors" v-validate="metadata.natfin.descricao.validator"></form-field>
        </div>
        <div class="row d-flex flex-column">
          <form-field v-model="natfin.codnatfinpai" type="select2" col="4" :metadata="metadata.natfin.codnatfinpai"
            name="codnatfinpai" :v-errors="errors" v-validate="metadata.natfin.codnatfinpai.validator" :disabled="true"
            parent="natfin" :select2="{ entity: select2Natfin, minlength: 0 }"></form-field>
          <!-- NAT SUPERIOR NAO PODE SER ALTERADA
                <form-field v-model="natfin.codnatfinpai" type="select2" col="4" :metadata="metadata.natfin.codnatfinpai"
                    name="codnatfinpai" :v-errors="errors" v-validate="metadata.natfin.codnatfinpai.validator" :disabled="true"
                    parent="natfin" :select2="{entity: select2Natfin, minlength: 0}" @input="handleInputPai"></form-field>
                <span class="error ml-3" v-if="natfinPaiError">{{ natfinPaiErrorMsg }}</span> -->
        </div>
        <div class="row d-flex flex-column">
          <div class="col-md-12 col-12">
            <input-checkbox v-model="natfin.entradre" label="Considera no DRE?" value-checked="S"
              value-unchecked="N"></input-checkbox>
          </div>
          <form-field v-if="natfin.entradre == 'S'" v-model="natfin.coddre" type="select2" col="4"
            :metadata="metadata.natfin.coddre" name="coddre" :v-errors="errors"
            v-validate="metadata.natfin.coddre.validator" parent="natfin"
            :select2="{ entity: select2DRE, minlength: 0 }"></form-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { SysVars } from '../main'
import { apiORDS, apiORDSpost, apiORDSdelete } from '../shared/api-functions'

export default {
  props: {
    index: '',
    crud: '',
    codNatfinPai: '',
    natfinType: ''
  },

  data() {
    return {
      crudText: '',
      natfin: { ...this.$store.getters.getEntities.natfin },
      metadata: this.$store.getters.getEntities.metadata,
      errmessages: [],  //armazena as mensagens de validacao do servidor para mostrar em tela
      select2Natfin: '',
      select2DRE: '',
      natfinPaiError: false,
      natfinPaiErrorMsg: ''
    }
  },

  computed: {
    editing: function () {
      return this.crud == SysVars.crudU
    }
  },

  methods: {
    closeForm() {
      this.$emit('closeform', this.natfin.codnatfin)
    },

    handleSave() {
      //BOTAO SALVAR

      if (this.natfinPaiError) {
        this.$erpToastError('Por favor, corrija os campos com alerta em vermelho')
        return
      }

      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
        } else {
          this.apiPost()
        }
      })
    },

    handleDelete() {
      //BOTAO Excluir
      this.apiDelete()
    },

    handleInputPai() {
      // remove a msg de erro
      this.natfinPaiError = false

      let self = this
      let codnatfinpai = this.natfin.codnatfinpai ? this.natfin.codnatfinpai : ''
      let url = this.$store.getters.urlOrds + 'cg/natfin/' + codnatfinpai

      apiORDS(url, {}).then((result) => {
        if (result.items && result.items.length) {

          let selectedNatfinPai = result.items[0]

          if (self.natfin.codnatfin == selectedNatfinPai.codnatfin) {
            this.natfinPaiError = true
            this.natfinPaiErrorMsg = 'Este item não pode ter ele mesmo como sua própria natureza superior!'
            return
          }

          if (self.natfin.haschildren) {
            if (selectedNatfinPai.nivel != 1) {
              this.natfinPaiErrorMsg = 'A Natureza Superior selecionada deve possuir nível 1!'
              this.natfinPaiError = true
              return
            }
          }

          if (selectedNatfinPai.nivel == 3) {
            this.natfinPaiErrorMsg = 'Nenhum item pode ser movido para dentro de um item de nível 3!'
            this.natfinPaiError = true
            return
          }
        }
      })
    },

    async loadData() {
      //carrega o registro para alteracao ou visualizacao
      await this.$store.dispatch('loadNatfin', { id: this.index })
      if (this.$store.getters.getNatfin) {
        this.natfin = { ...this.$store.getters.getNatfin }
      }
      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip()
      })
    },

    async apiDelete() {
      //efetua a exclusao
      var modulo = 'cg/natfin/' + this.natfin.codnatfin

      const data = await apiORDSdelete(this.$store, modulo)
      this.$erpToastDeleted()
      this.closeForm()
    },

    async apiPost() {
      //efetua a gravacao

      var modulo = 'cg/natfin/'
      var sendData = {}

      sendData = { natfin: this.natfin }

      let metodo = 'post'
      let update = false
      if (this.crud != SysVars.crudI) {
        metodo = 'put'
        update = true
      }

      const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
      if (data.errmessages) {
        this.errmessages = data.errmessages
        this.$erpToastError('Alguns erros precisam ser corrigidos.')
      } else {
        if (update) {
          this.$erpToastUpdated()
        } else {
          this.$erpToastInserted()
        }
        this.errmessages = {}
        this.closeForm()
      }
    },

  },

  components: {

  },

  beforeCreate() {

  },

  created() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip()
    })

    this.crudText = this.$crudText(this.crud)

    if (this.crud == SysVars.crudI) {
      this.natfin.entradre = 'N'
      if (this.codNatfinPai) {
        this.natfin.codnatfinpai = this.codNatfinPai
      }
    } else {
      this.loadData()
    }

    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip()
      this.$refs.descricao.focus()
    })

    if (this.natfinType) {
      if (this.natfinType == 'R') {
        this.select2Natfin = 'natfin/receitas'
        this.select2DRE = 'dre/receitas'
      } else {
        this.select2Natfin = 'natfin/despesas'
        this.select2DRE = 'dre/despesas'
      }
      this.natfin.tpnatfin = this.natfinType
    }
  }

}

</script>

<style></style>



// WEBPACK FOOTER //
// src/forms/natfin-form.vue